interface ConversationLoadingProps {
  variant: 'route' | 'history';
}

export function ConversationLoading({ variant }: ConversationLoadingProps) {
  const positioning =
    variant === 'route'
      ? 'absolute inset-x-0 top-16 z-30 h-[calc(100dvh-4rem)] bg-[#070400]'
      : 'min-h-[calc(100dvh-8rem)] py-6';

  return (
    <div
      role="status"
      aria-live="polite"
      data-conversation-loading={variant}
      className={`flex flex-col items-center justify-center ${positioning}`}>
      <div className="h-12 w-12 animate-spin rounded-full border-2 border-white/15 border-t-[#F98715]" />
      <p className="mt-4 text-white">Loading conversation...</p>
    </div>
  );
}
